import { db } from '../firebase';
import { collection, getDocs, updateDoc, doc } from 'firebase/firestore';

export async function resetTransferCounts() {
  try {
    const usersRef = collection(db, 'users');
    const usersSnapshot = await getDocs(usersRef);
    
    let updatedCount = 0;
    let skippedCount = 0;
    let errorCount = 0;
    
    for (const userDoc of usersSnapshot.docs) {
      try {
        await updateDoc(doc(db, 'users', userDoc.id), {
          transferCount: 0,
          transfers: 0,
          transfer_count: 0
        });

        updatedCount++;
      } catch (userError) {
        console.error(`Error processing user ${userDoc.id}:`, userError);
        errorCount++;
      }
    }

    return {
      success: true,
      updatedCount,
      skippedCount,
      errorCount
    };
  } catch (error) {
    console.error('Error resetting transfer counts:', error);
    return {
      success: false,
      error: error.message
    };
  }
} 